export function InitTextInputAutoSelect() {
    //auto-select text-input contents on "click"
    //to avoid selecting text-input contents when the user already is making/has made a selection,
    //wait for the auto-selection for the mouse-up event.
    //but the mouse up-event corresponding to a mouse-focus event may occur on an entirely unrelated element
    //so we need to listen on window, and explicitly check whether the right sequence of events has occured.
    //We can ignore text-based focus changes, because default browser behavior there is already good.

    //conceptually, we're waiting for
    // 1. a mousedown (on an input)
    // 2. that input gaining focus
    // 3. the mouseup event occuring on the same input
    // 4a. there being no text selected (typical e.g. on the first time the input was selected)
    // 4b OR all text being selected (typical e.g. on an input that was previously autoselected)

    // If that chain of events is interrupted at any time by focus/mouseup/mousedown events on anything else in the page, start over.

    let inputWaitingForFocus: HTMLInputElement | null = null;
    let inputWaitingForMouseUp: HTMLInputElement | null = null;
    addEventListener(
        "mousedown",
        function (e) {
            inputWaitingForFocus = e.target instanceof HTMLInputElement && e.target.type === "text" ? e.target : null;
            inputWaitingForMouseUp = null;
        });
    addEventListener(
        "focus",
        function (e) {
            inputWaitingForMouseUp = inputWaitingForFocus === e.target ? inputWaitingForFocus : null;
            inputWaitingForFocus = null;
        },
        true); //use capture, because focus won't bubble
    addEventListener(
        "mouseup",
        function (e) {
            const inputFocusedViaMouse = e.target === inputWaitingForMouseUp ? inputWaitingForMouseUp : null;
            inputWaitingForFocus = null;
            inputWaitingForMouseUp = null;
            if (inputFocusedViaMouse) {
                const selectionEmpty = inputFocusedViaMouse.selectionStart === inputFocusedViaMouse.selectionEnd;
                const selectionComplete = inputFocusedViaMouse.selectionStart === 0 && inputFocusedViaMouse.selectionEnd === inputFocusedViaMouse.value.length;
                if (selectionEmpty || selectionComplete) {
                    inputFocusedViaMouse.select();
                }
            }
        });
};
